import { isUndefined } from 'lodash';

export const transformGeneralInfo = (raw) => ({
  logo: raw?.logo || [],
  name: raw?.name || '',
  website_url: raw?.website_url || '',
  industry: raw?.industry || '',
  customer_service_number: raw?.customer_service_number || '',
  email: raw?.email || '',
  // business_address: raw?.business_address || '',
  district: raw?.business_address?.district || '',
  street: raw?.business_address?.street || '',
  house_no: raw?.business_address?.house_no || '',
  building_name: raw?.business_address?.building_name || '',
  unit_no: raw?.business_address?.unit_no || '',
  postal_code: raw?.business_address?.postal_code || '',
  // business_geoloc: raw?.business_geoloc || '',
  business_description: raw?.business_description || '',
  business_number_of_customers: raw?.business_number_of_customers || '',
  business_monthly_sales: raw?.business_monthly_sales || '',
  business_type: raw?.business_type || '',
  current_step: raw?.current_step ? parseInt(raw?.current_step, 10) : 0,
});

export const transformBusinessCorporation = (raw) => {
  let isBeneficialOwner = '';
  isBeneficialOwner = raw?.is_beneficial_owner || '';
  if (!isUndefined(raw?.is_beneficial_owner)) {
    isBeneficialOwner = raw?.is_beneficial_owner ? 'Yes' : 'No';
  }
  return {
    first_name: raw?.first_name || '',
    last_name: raw?.last_name || '',
    // home_address: raw?.home_address || '',
    district: raw?.home_address?.district || '',
    street: raw?.home_address?.street || '',
    house_no: raw?.home_address?.house_no || '',
    building_name: raw?.home_address?.building_name || '',
    unit_no: raw?.home_address?.unit_no || '',
    postal_code: raw?.home_address?.postal_code || '',
    // home_geoloc: raw?.home_geoloc || '',
    is_beneficial_owner: isBeneficialOwner,
    owner_id_image_url: raw?.owner_id_image_url || [],
    business_legal_name: raw?.business_legal_name || '',
    business_registration_number: raw?.business_registration_number || '',
    business_incorporation_date: raw?.business_incorporation_date || '',
    cert_of_corporation_imge_url: raw?.cert_of_corporation_imge_url || [],
    form_x_image_url: raw?.form_x_image_url || [],
    business_local_director_ic_image_url:
      raw?.business_local_director_ic_image_url || [],
    bank_name: raw?.bank_name || '',
    bank_account_name: raw?.bank_account_name || '',
    bank_account_number: raw?.bank_account_number || '',
  };
};

export const transformBusinessSole = (raw) => ({
  first_name: raw?.first_name || '',
  last_name: raw?.last_name || '',
  district: raw?.home_address?.district || '',
  street: raw?.home_address?.street || '',
  house_no: raw?.home_address?.house_no || '',
  building_name: raw?.home_address?.building_name || '',
  unit_no: raw?.home_address?.unit_no || '',
  postal_code: raw?.home_address?.postal_code || '',
  // home_address: raw?.home_address || '',
  // home_geoloc: raw?.home_geoloc || '',
  owner_id_image_url: raw?.owner_id_image_url || [],
  business_cert_image_url: raw?.business_cert_image_url || [],
  business_local_owner_ic_image_url:
    raw?.business_local_owner_ic_image_url || [],
  business_legal_name: raw?.business_legal_name || '',
  business_registration_number: raw?.business_registration_number || '',
  business_incorporation_date: raw?.business_incorporation_date || '',
  bank_name: raw?.bank_name || '',
  bank_account_name: raw?.bank_account_name || '',
  bank_account_number: raw?.bank_account_number || '',
});

export const transformBusinessIndividual = (raw) => ({
  first_name: raw?.first_name || '',
  last_name: raw?.last_name || '',
  district: raw?.home_address?.district || '',
  street: raw?.home_address?.street || '',
  house_no: raw?.home_address?.house_no || '',
  building_name: raw?.home_address?.building_name || '',
  unit_no: raw?.home_address?.unit_no || '',
  postal_code: raw?.home_address?.postal_code || '',
  // home_address: raw?.home_address || '',
  // home_geoloc: raw?.home_geoloc || '',
  owner_id_image_url: raw?.owner_id_image_url || [],
  business_duration: raw?.business_duration || 'Less than 1 year',
  bank_name: raw?.bank_name || '',
  bank_account_name: raw?.bank_account_name || '',
  bank_account_number: raw?.bank_account_number || '',
});

export const transformBusinessPartner = (raw) => ({
  first_name: raw?.first_name || '',
  last_name: raw?.last_name || '',
  district: raw?.home_address?.district || '',
  street: raw?.home_address?.street || '',
  house_no: raw?.home_address?.house_no || '',
  building_name: raw?.home_address?.building_name || '',
  unit_no: raw?.home_address?.unit_no || '',
  postal_code: raw?.home_address?.postal_code || '',
  // home_address: raw?.home_address || '',
  // home_geoloc: raw?.home_geoloc || '',
  owner_id_image_url: raw?.owner_id_image_url || '',
  business_legal_name: raw?.business_legal_name || '',
  business_registration_number: raw?.business_registration_number || '',
  business_incorporation_date: raw?.business_incorporation_date || '',
  sec_cert_of_partnership_image_url:
    raw?.sec_cert_of_partnership_image_url || '',
  art_of_partnership_image_url: raw?.art_of_partnership_image_url || '',
});

export const transformBusinessGovernment = (raw) => ({
  first_name: raw?.first_name || '',
  last_name: raw?.last_name || '',
  district: raw?.home_address?.district || '',
  street: raw?.home_address?.street || '',
  house_no: raw?.home_address?.house_no || '',
  building_name: raw?.home_address?.building_name || '',
  unit_no: raw?.home_address?.unit_no || '',
  postal_code: raw?.home_address?.postal_code || '',
  owner_id_image_url: raw?.owner_id_image_url || [],
  government_ministry: raw?.government_ministry || '',
  date_of_government_official_letter:
    raw?.date_of_government_official_letter || '',
  government_official_letter_refno: raw?.government_official_letter_refno || '',
  authorised_name_of_contact_person:
    raw?.authorised_name_of_contact_person || '',
  authorised_contact_person_ic_no: raw?.authorised_contact_person_ic_no || '',
  ministry_appointment_letter_img_url:
    raw?.ministry_appointment_letter_img_url || [],
  ministry_letter_for_appointed_img_url:
    raw?.ministry_letter_for_appointed_img_url || [],
  ic_authorised_person_img_url: raw?.ic_authorised_person_img_url || [],
  bank_name: raw?.bank_name || '',
  bank_account_name: raw?.bank_account_name || '',
  bank_account_number: raw?.bank_account_number || '',
});

export const transformCheckSavedBusinessInfo = (raw) => ({
  CORPORATION: raw?.merchant_info_corporate || false,
  SOLE_PROPRIETORSHIP: raw?.merchant_info_sole_proprietorship || false,
  INDIVIDUAL: raw?.merchant_info_individual || false,
  GOVERNMENT: raw?.merchant_info_government || false,
});
